import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../services/login.service';
import { ApiResponse } from '../models/APIResponse';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  username: string;
  tempPassword: string;
  password: string;
  confirmPassword: string;
  message: string;
  failed: boolean;
  changetype: string;
  changetypetext: string;

  constructor(private loginService: LoginService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.username = this.route.snapshot.queryParamMap.get('username');
    this.changetype = this.route.snapshot.queryParamMap.get('changetype');
    this.changetype === '1' ? this.changetypetext = 'Temporary Password' : this.changetypetext = 'Old Password';
  }

  onChangePassClick(tempPass, pass, confirmPass) {
    this.message = "";
    this.failed = false;
    const self = this;
    this.loginService.updateResetPassword(this.username, tempPass, pass)
      .subscribe((res: ApiResponse) => {
        if (res.success) {
          this.loginService.login(self.username, pass)
            .subscribe((res: any) => {
              if (res.success) {
                self.loginService.setUserContextDetail(res.modelRet);
                self.router.navigate(['/Billing/Usage']);
              }
            });
        } else {
          this.failed = true;
          this.message = res.message;
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts